import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import { Checkbox, Heading, Paragraph, ValidationMessage } from '@digdir/designsystemet-react';

import { OppvarmingFormData } from '../../../types';
import { CheckedContentWrapper, LeftBorderedContent } from '../common/styledComponents';
import { useOppvarmingValidation } from '../../hooks/useOppvarmingValidation';
import { oppvarmingSelectionFields } from '../../utils';

import { ApenPeis } from './components/apenPeis';
import { LukketOvn } from './components/lukketOvn';
import { PeisMedDor } from './components/peisMedDor';

export const Ved = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { validateOppvarmingSelection } = useOppvarmingValidation();

  const { t } = useTranslation();

  const vedSelected = watch('ved.selected');
  const vedError = formState.errors?.ved?.selected?.message;
  const vedSelectionError = formState.errors?.ved?.value?.apenPeis?.selected?.message;

  return (
    <Fragment>
      <Checkbox
        aria-invalid={!!vedError}
        label={t('form.oppvarming.ved.label')}
        {...register('ved.selected', {
          validate: validateOppvarmingSelection,
          deps: oppvarmingSelectionFields,
          shouldUnregister: true
        })}
      />

      {vedSelected && (
        <CheckedContentWrapper>
          <LeftBorderedContent>
            <Heading level={3} data-size="2xs">
              {t('register.tekniskUtstyr.oppvarmingVed.heading')}
            </Heading>
            <Paragraph className="text-preline">{t('form.oppvarming.ved.description')}</Paragraph>
          </LeftBorderedContent>

          <ApenPeis />
          <LukketOvn />
          <PeisMedDor />
          {vedSelectionError && (
            <LeftBorderedContent>
              <ValidationMessage>{vedSelectionError}</ValidationMessage>
            </LeftBorderedContent>
          )}
        </CheckedContentWrapper>
      )}
    </Fragment>
  );
};
